import { graphql } from "gql";

const DELETE_JOB_MUTATION = graphql(`
  mutation DeleteJob($id: ID!) {
    deleteJob(id: $id)
  }
`);

export default DELETE_JOB_MUTATION;
